import * as React from 'react';

import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import FormEditingHandler from 'Containers/FormEditingHandler';

import Form from './Form';
import _BPHistory from './HistoryRowData';

const _BP = ({ documents }: IOwnProps): React.JSX.Element => (
  <FormEditingHandler name="_BP" documents={documents}>
    {(editing, startEdit, formData, view): React.JSX.Element => (
      <DocumentWrapper>
        <DocumentHeader name={'_BP'} headerId={'_BP.title'} editing={editing} editButtons={<div />} />
        {editing ? <Form formData={formData} /> : null}
        {!editing && !view?.viewing ? <_BPHistory documents={documents} startEdit={startEdit} /> : null}
      </DocumentWrapper>
    )}
  </FormEditingHandler>
);

interface IOwnProps {
  documents: Array<IDocumentV2>;
}

export default _BP;
